<template>
  <div>
    <b-spinner v-if="loading" label="Loading..." small></b-spinner>
    <div v-if="photos.length" class="row mb-3">
      <article class="card col-12">
        <header class="card-header">
          <i class="fal fa-camera mr-1"></i>
          <h5 class="card-title" v-html="header"></h5>
        </header>
        <section class="card-body">
          <div class="card-columns">
            <article class="card" v-for="(photo, index) in photos" :key="index">
              <div class="card-img">
                <a :href="photo.photo" target="_blank">
                  <img :src="photo.thumbnail" class="img-fluid img-thumbnail"/>
                </a>
              </div>
            </article>
          </div>
        </section>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    path: String
  },
  data() {
    return {
      photos: [],
      header: '',
      loading: false,
    };
  },
  created() {
    this.loading = true;
    this.axios.get(this.path)
        .then(response => {
          this.photos = response.data.photos;
          this.header = response.data.header;
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status >= 400 && error.response.status < 500) {
              // Output a console warning for 4xx errors
              console.warn(`An error occurred (HTTP ${error.response.status}):`, error.response.data.error);
            } else {
              // Log other types of errors (such as network errors)
              console.error("An unexpected error occurred:", error);
            }
          } else {
            // General error (if no response object is available)
            console.error("General error:", error);
          }
        })
        .finally(() => {
          this.loading = false;
        });
  },
};
</script>
